import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
// @ts-nocheck
// tslint:disable
export var ImageData = /*#__PURE__*/function () {
  function ImageData() {
    _classCallCheck(this, ImageData);

    var len = arguments.length;

    if (len === 2) {
      if (typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        this._w = arguments[0];
        this._h = arguments[1];
        this._data = new Uint8ClampedArray(this._w * this._h * 4);
        return;
      }
    } else if (len === 3) {
      if (_typeof(arguments[0]) === 'object' && typeof arguments[1] === 'number' && typeof arguments[2] === 'number') {
        this._data = arguments[0];
        this._w = arguments[1];
        this._h = arguments[2];
      }
    }

    throw new Error('ImageData: params error');
  }

  _createClass(ImageData, [{
    key: "width",
    get: function get() {
      return this._w;
    }
  }, {
    key: "height",
    get: function get() {
      return this._h;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }]);

  return ImageData;
}();